import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';

import { SlideProps } from './types';
import styles from './styles.module.less';

const Slide = (props: PropsWithChildren<SlideProps>) => {
  return (
    <div className={classNames(styles["container"])}>
      {props.children}
    </div>
  );
};

Slide.displayName = 'Slide';

export default Slide;
